import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ru from './ru/main'
import en from './en/main'
Vue.use(VueI18n)

// Инициализация:
const i18n = new VueI18n({
	availableLocales: ['ru', 'en'],
	fallbackLocale: 'ru',
	messages: { ru, en },
})

// Определение сохраненной локали, или же локали браузера:
let locale =
	localStorage.getItem('userLocale') || window.navigator.language.slice(0, 2)
if (locale == 'ru') i18n.locale = 'ru'
else i18n.locale = 'en'

// Экспорт:
export default i18n
